import {
  AfterContentInit,
  Component,
  contentChildren, ElementRef, inject, Injectable, input,
  signal,
  TemplateRef,
  viewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {TemplateForDirective} from "../../templating";
import {FlexModule} from "@ngbracket/ngx-layout";
import {NgTemplateOutlet} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class ViewScrolling {

  scrollToTop: (behavior?: ScrollToOptions['behavior']) => void = (behavior) => {
    this.scrollTo({
      top: 0,
      behavior: behavior ?? 'smooth'
    });
  };

  scrollTo: (options?: ScrollToOptions) => void = (options) => {
    window.scrollTo(options ?? {top: 0, behavior: 'smooth'});
  }
  scrollIntoView: (element: HTMLElement|null|undefined, options?: ScrollIntoViewOptions) => void = (element, options) => {
    if (!element) {
      return;
    }
    element.scrollIntoView(options);
  }
}

@Component({
  selector: 'app-lib-inner-scrollable',
  imports: [
    FlexModule,
    NgTemplateOutlet
  ],
  templateUrl: './inner-scrollable.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './inner-scrollable.component.css'
})
export class InnerScrollableComponent implements AfterContentInit {

  templates = contentChildren(TemplateForDirective);
  header = signal<TemplateRef<unknown>|undefined>(undefined);
  footer = signal<TemplateRef<unknown>|undefined>(undefined);
  pinFooter = input(true);
  contentElement = viewChild.required<ElementRef<HTMLDivElement>>('content');

  constructor() {
    const scrolling = inject(ViewScrolling);
    scrolling.scrollTo = this.scrollTo.bind(this);
    scrolling.scrollIntoView = this.scrollIntoView.bind(this);
    scrolling.scrollToTop = this.scrollToTop.bind(this);
  }

  scrollTo(options?: ScrollToOptions) {
    options ??= {top: 0, behavior: 'smooth'};
    this.contentElement().nativeElement.scrollTo(options);
  }

  scrollIntoView(element: HTMLElement|null|undefined, options?: ScrollIntoViewOptions) {

    if (!element) {
      return;
    }
    element.scrollIntoView(options);
  }

  scrollToTop(behavior?: ScrollToOptions['behavior']) {
    behavior ??= 'smooth';
    this.scrollTo({
      top: 0,
      behavior
    });
  }

  ngAfterContentInit() {
    TemplateForDirective.Bind(this, this.templates());
  }
}

